<template>
	<div class="">
		<headers></headers>
		<div class="bg-theme">
			<div class="container  d-flex flex-wrap py-4  align-items-center">
				<img :src="mainIndex_head_img" class="img-fluid col-md-6 mt-4" alt="...">
				<div class="d-flex flex-column align-items-center  main-wid-100 main-mp-1" style="flex: 1;">
					<div class="ftr-2-5 ftw600">
						<!-- 1对1 專業導師 -->
						{{$t('mainIndex.titleOne')}}
					</div>
					<div class="h4 ftw600 mt-4 text-center">
						<!-- 個性化教學·互動專注學習 -->
						{{$t('mainIndex.titleTwo')}}
					</div>
					<button type="button" class="btn btn-outline-dark mt-4 btn-lg ftw600" @click="toTeacher">{{$t('common.startImmediately')}}</button>
				</div>
			</div>
			
		</div>
		<!-- 轮播 -->
		<div class="bg-w py-4">
			<a-carousel arrows autoplay :autoplaySpeed="2000">
				<div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-Index: 10;">
					<a-icon type="arrow-left" />
				</div>
				<div slot="nextArrow" class="custom-slick-arrow" style="right: 10px;z-index: 10;">
					<a-icon type="arrow-right" />
				</div>
				<div class="d-flex justify-content-center mainIndex-class-car flex-wrap">
					<img :src="mainIndex_evaluate_list[0]" alt="" class="me-3" style="width: 200px;height: 100%;" />
					<div class="d-flex flex-column align-content-start">
						<div class="h4 ftw600 cl-black">
							<!-- 聽聽MiraStudent學生的評價 -->
							{{$t('mainIndex.evaluate')}}
						</div>
						<div class="mt-3 ft18 cl-black">
							多謝MiraStudent，讓我多了時間参加课外活動·而且数學成績遭突飛猛進!
						</div>
						<div class="mt-3 ft18 cl-black">
							Danny
						</div>
						<div class="cl-info">
							在 MiraStudent 学习数学
						</div>
						<div class="" style="height: 30px;"></div>
					</div>
				</div>
				<div class="d-flex justify-content-center mainIndex-class-car">
					<img :src="mainIndex_evaluate_list[0]" alt="" class="me-3" style="width: 200px;height: 100%;" />
					<div class="d-flex flex-column align-content-start">
						<div class="h4 ftw600 cl-black">
							聽聽MiraStudent學生的評價
						</div>
						<div class="mt-3 ft18 cl-black">
							多謝MiraStudent，讓我多了時間参加课外活動·而且数學成績遭突飛猛進!
						</div>
						<div class="mt-3 ft18 cl-black">
							Danny
						</div>
						<div class="cl-info">
							在 MiraStudent 学习数学
						</div>
						<div class="" style="height: 30px;"></div>
					</div>
				</div>
				<div class="d-flex justify-content-center mainIndex-class-car">
					<img :src="mainIndex_evaluate_list[0]" alt="" class="me-3" style="width: 200px;height: 100%;" />
					<div class="d-flex flex-column align-content-start">
						<div class="h4 ftw600 cl-black">
							聽聽MiraStudent學生的評價
						</div>
						<div class="mt-3 ft18 cl-black">
							多謝MiraStudent，讓我多了時間参加课外活動·而且数學成績遭突飛猛進!
						</div>
						<div class="mt-3 ft18 cl-black">
							Danny
						</div>
						<div class="cl-info">
							在 MiraStudent 学习数学
						</div>
						<div class="" style="height: 30px;"></div>
					</div>
				</div>
				<div class="d-flex justify-content-center mainIndex-class-car">
					<img :src="mainIndex_evaluate_list[0]" alt="" class="me-3" style="width: 200px;height: 100%;" />
					<div class="d-flex flex-column align-content-start">
						<div class="h4 ftw600 cl-black">
							聽聽MiraStudent學生的評價
						</div>
						<div class="mt-3 ft18 cl-black">
							多謝MiraStudent，讓我多了時間参加课外活動·而且数學成績遭突飛猛進!
						</div>
						<div class="mt-3 ft18 cl-black">
							Danny
						</div>
						<div class="cl-info">
							在 MiraStudent 学习数学
						</div>
						<div class="" style="height: 30px;"></div>
					</div>
				</div>
			</a-carousel>
		</div>
		<div class=" text-center"  v-if="showAlert">
			
			<div  role="alert" class="alert alert-dark alert-dismissible fade show">
				<!-- 本網站使用 Cookie 以提供最佳的使用體驗，同時保障您的安全瀏覽。欲了解更多關於 Cookie 的資訊，請參閱我們的隱私權政策。 了解更多。 -->
				本網站透廻使用 Cookie 來評估您在本站的使用情況，從而提供最佳的测覧體驗。如果您繼结使用本網站，即表示您同意我價使用 Cookie 收集數據
				詳情請參開使用條款、隱私政策和 Cookie 政策。
				<div class="btn-close" @click="setAlert()">
					
				</div>
			</div>
			
		</div>
		
		<!-- 线上補習平台 -->
		<!-- <div class="container py-2 text-center">
			<div class="h3 ftw600 mt-4 ">
				
				{{$t('mainIndex.titleThree')}}
			</div>
			<div class="ftr-1-2 mt-2">
				{{$t('mainIndex.titleFour')}}<br />
				{{$t('mainIndex.titleFive')}}
			</div>
		</div> -->
		<!-- 科目列表 -->
		<div class="container py-2 bg-w mt-4">
			<!-- 熱門補習科目 -->
			<!-- <div class="ftr-1-25 ftw600">
				{{$t('mainIndex.titleSubject')}}
			</div>
			<div class="py-2 d-flex flex-wrap ">
				<div class="mainIndex-language-item clickAct d-flex align-items-center justify-content-between border py-5 px-3 br8 "
					v-for="(item,index) in courseList" @click="toSearchClass(item.id)">
					<div class="d-flex align-items-center">
						<img :src="item.image" alt=""
							style="width: 60px;height: 60px;margin-right: 8px;" />
						{{item.name}}
					</div>
					<a-icon type="right" class="ft20" style="color: rgba(0, 0, 0, 0.4);"></a-icon>
				</div>
			</div> -->
			<!-- <div class="text-end">
				{{$t('mainIndex.viewMore')}}...
			</div> -->
			
			<div v-for="(item,index) in list">
				<div v-if="item.course&&item.course.length!=0&&item.name.includes('DSE')">
					<div class="ftr-1-25 ftw600 mt-4" >
						{{item.name}}
					</div>
					<div class="py-2 d-flex flex-wrap ">
						<div class="mainIndex-language-item clickAct d-flex align-items-center justify-content-between border py-5 px-3 br8"
							v-for="(it,ind) in item.course" @click="toSearchClass(it.id)" v-if="ind<item.showLength">
							<div class="d-flex align-items-center">
								<img :src="it.image" alt=""
									style="width: 60px;height: 60px;margin-right: 8px;" />
								{{it.name}}
							</div>
							<a-icon type="right" class="ft20" style="color: rgba(0, 0, 0, 0.4);"></a-icon>
						</div>
					</div>
					<div class="d-flex justify-content-center " style="width: 100%;" v-if="item.course&&item.course.length!=0">
						<div class="btn btn-outline-theme" style="width: 100px;"  @click="item.showLength==12?item.showLength=10000:item.showLength=12">
							{{item.showLength==12?$t('common.showMore'):$t('common.foldUp')}}
						</div>
					</div>
				</div>
				<div v-if="item.course&&item.course.length!=0&& !item.name.includes('DSE')">
					<div class="ftr-1-25 ftw600 mt-4" >
						{{item.name}}
					</div>
					<div class="py-2 d-flex flex-wrap ">
						<div class="mainIndex-language-item clickAct d-flex align-items-center justify-content-between border py-5 px-3 br8"
							v-for="(it,ind) in item.course" @click="toSearchClass(it.id)" v-if="(ind<item.showLength) ">
							<div class="d-flex align-items-center">
								<img :src="it.image" alt=""
									style="width: 60px;height: 60px;margin-right: 8px;" />
								{{it.name}}
							</div>
							<a-icon type="right" class="ft20" style="color: rgba(0, 0, 0, 0.4);"></a-icon>
						</div>
					</div>
					<div class="d-flex justify-content-center " style="width: 100%;" v-if="item.course&&item.course.length!=0">
						<div class="btn btn-outline-theme" style="width: 100px;" @click="item.showLength==6?item.showLength=10000:item.showLength=6;">
							{{item.showLength==6?$t('common.showMore'):$t('common.foldUp')}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 搜索 -->
		<div class="container py-4 bg-theme d-flex flex-column align-items-center">
			<div class="ftr-2-5 ftw600">
				{{$t('common.nofind')}}
			</div>
			<div class="h5 ftw600 mt-2 ">
				{{$t('common.helpFind')}}
			</div>
			<div class="btn btn-outline-dark mt-1" @click="toSearchClass(0)">
				{{$t('common.searchNow')}}
			</div>
			<!-- <a-input-search placeholder="开始搜索" class="mt-4 mainIndex-class-search"  @click="toSearchClass(0)" /> -->
		</div>

		<!-- 选择原因 -->
		<div class="container py-4 bg-w d-flex flex-column align-items-center">
			<div class="ftr-2-5 ftw600">
				{{$t('mainIndex.reasonForSelection')}}
			</div>
			<div class="row mt-4 main-wid-100" style="width: 70%;justify-content: space-around;">
				<div class="d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/1.png" alt="" class="mainIndex-photo"/>
					<div class="">
						<div class="ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitleOne')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContentOne')}}
						</div>
					</div>
				</div>
				
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/2.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class=" ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitleTwo')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContentTwo')}}
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-4 main-wid-100" style="width: 70%;justify-content: space-around;">
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/3.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							<!-- 度身訂造専靥課程 -->
							{{$t('mainIndex.reasonTitlethree')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContentThree')}}
						</div>
					</div>
				</div>
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/4.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitlefour')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContentFour')}}
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-4 main-wid-100" style="width: 70%;justify-content: space-around;">
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/5.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitle5')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContent5')}}
						</div>
					</div>
				</div>
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/6.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitle7')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContent7')}}
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-4 main-wid-100" style="width: 70%;justify-content: space-around;">
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/7.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							<!-- 度身訂造専靥課程 -->
							{{$t('mainIndex.reasonTitle6')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContent6')}}
						</div>
					</div>
				</div>
				<div class=" d-flex  align-items-center border-gray br4 px-2 py-2" style="width: 48%;">
					<img src="../assets/image/index/8.png" alt="" class="mainIndex-photo" />
					<div class="">
						<div class="ftr-1-25 cl-theme">
							{{$t('mainIndex.reasonTitle8')}}
						</div>
						<div class="">
							{{$t('mainIndex.reasonContent8')}}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 上课流程 -->
		<div class="container py-4 bg-w d-flex flex-column align-items-center" >
			<div class="ftr-1-25">
				{{$t('mainIndex.howUsed')}}
			</div>
			<div class="h4 mt-2">
				{{$t('mainIndex.classProcess')}}
			</div>
			
			<div class="row d-flex justify-content-around mt-3" style="width: 85%;flex-wrap: wrap;">
				<div class="br4 border-gray px-2 py-2 col-md-6 main-wid-30" >
					<div class="flex ">
						<div class="mainIndex-used-circle" style="background-color: #FFC000;">
							1
						</div>
						<div class="ft18 ftw500">{{$t('mainIndex.processOne_1')}}</div>
					</div>
					<div class="mt-2">
						{{$t('mainIndex.processOne_2')}}
					</div>
					<div class="flex mt-2">
						<div>1.</div>
						<div class="ml10">
							{{$t('mainIndex.processOne_3')}}
						</div>
					</div>
					<div class="flex mt-2">
						<div>2.</div>
						<div class="ml10">
							{{$t('mainIndex.processOne_4')}}
						</div>
					</div>
					<div class="flex mt-2">
						<div>3.</div>
						<div class="ml10">
							{{$t('mainIndex.processOne_5')}}
						</div>
					</div>
					<div class="flex center mt-3">
						<img src="../assets/image/index/used1.png" alt="" style="width: 60px;height: 60px;" />
					</div>
				</div>
				<div class="br4 border-gray px-2 py-2 main-wid-30" style="position: relative;">
					<div class="flex ">
						<div class="mainIndex-used-circle" style="background-color: #5B9BD5;">
							2
						</div>
						<div class="ft18 ftw500">{{$t('mainIndex.processTwo_1')}}</div>
					</div>
					<div class="mt-2">
						{{$t('mainIndex.processTwo_2')}}
					</div>
					<div class="flex mt-2">
						{{$t('mainIndex.processTwo_3')}}
					</div>
					<div class="flex mt-2">
						{{$t('mainIndex.processTwo_4')}}
					</div>
					<div class="flex center mt-3" style="position: absolute;bottom: 0.5rem;left: 0;right: 0;">
						<img src="../assets/image/index/used2.png" alt="" style="width: 60px;height: 60px;" />
					</div>
				</div>
				<div class="br4 border-gray px-2 py-2 main-wid-30" style="position: relative;">
					<div class="flex ">
						<div class="mainIndex-used-circle" style="background-color: #78E5E2;">
							3
						</div>
						<div class="ft18 ftw500">{{$t('mainIndex.processThree_1')}}</div>
					</div>
					<div class="mt-2">
						{{$t('mainIndex.processThree_2')}}
					</div>
					<div class="flex mt-2">
						{{$t('mainIndex.processThree_3')}}
					</div>
					
					<div class="flex center mt-3" style="position: absolute;bottom: 0.5rem;left: 0;right: 0;">
						<img src="../assets/image/index/used3.png" alt="" style="width: 60px;height: 60px;" />
					</div>
				</div>
			</div>
			
			<button type="button" class="btn btn-outline-dark mt-4  ms-sm-3 bg-theme"
				style="width: 150px;border-radius: 0;border: 2px solid #000;font-weight: 600;" @click="toTeacher">
				{{$t('common.startImmediately')}}
			</button>
		</div>
		<!-- 成为老师 -->
		<div class="px-3 py-5 mainIndex-teacher text-center">
			<div class="cl-w h3">
				{{$t('headers.becomeTeacher')}}
			</div>
			<div class="cl-w mt-2">
				{{$t('mainIndex.obtainIncome')}}
				<br />
				<!-- 註册以開始使用 MiraTalker 網上授課 -->
				{{$t('mainIndex.onlineTeaching')}}
			</div>
			<div class="mainIndex-teacher-btn clickAct" style="margin: auto;margin-top: 1rem;" @click="toBecomeTeacher">
				{{$t('headers.becomeTeacher')}}
			</div>
		</div>
		
		<div class="container py-4 bg-w d-flex flex-column align-items-center">
			<div class="flex center ftr-1-25 cl-black">
				{{$t('common.askedQuestions')}}
			</div>
			<div class="mt-3" style="width: 100%;">
				<a-collapse v-model:activeKey="activeKey" style="width: 100%;" >
				   <a-collapse-panel :key="String(index) " :header="item.name " v-for="(item,index) in questionsList">
				     <p>{{ item.description }}</p>
				   </a-collapse-panel>
				 </a-collapse>
			</div>
			
		</div>
		<!-- 页脚 -->
		<footers></footers>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showMobileMenu: false,
				isMobile: false,
				list:[],
				courseList:[],
				showKefu:false,
				showAlert:!localStorage.getItem('showAlert') ? true:false,//banner问题提示是否显示
				activeKey:[],
				questionsList:[],
				mainIndex_head_img:'',
				mainIndex_evaluate_list:[],
				showLengthDse:12,
				showLengthOther:6,
			};
		},
		mounted() {
			// this.setUserInfo()
			this.classifyList()
			this.getCourseList()
			this.checkMobile();
			this.getCategory()
			this.getConfig()
			window.addEventListener('resize', this.checkMobile);
			
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkMobile);
		},
		methods: {
			setAlert(){
				this.showAlert = false
				localStorage.setItem('showAlert',true)
			},
			getConfig() {
				this.$http.api('index/config').then(res => {
					console.log("配置信息", res);
					this.mainIndex_head_img = res.info.mainIndex_head_img
					this.mainIndex_evaluate_list = res.info.mainIndex_evaluate_list.split(",")
				}).catch(err => {
					console.log("err", err);
				})
			},
			getCategory(){
				this.$http.api('index/category',{
					pid:14
				}).then(res=>{
					console.log("res",res);
					this.questionsList = res.list
				})
			},
			classifyList(){
				this.$http.api('course/classifyList',{
					includeCourse:1
				}).then(res=>{
					this.list = res.list
					this.list.forEach((item,index)=>{
						this.$set(item, 'showLength', 1);
						if(item.name.includes('DSE')){
							item.showLength = 12
						}else{
							item.showLength = 6
						}
					})
				})
			},
			getCourseList(){
				this.$http.api('course/courseList',{
					
				}).then(res=>{
					this.courseList = res.list
				})
			},
			toLogin() {
				this.$router.push('/login');
				this.showMobileMenu = false;
			},
			toSearchClass(id){
				this.$router.push('/classIndex?id='+id);
			},
			toTeacher(){
				// this.$router.push('/personalizationTeacher');
				if(!this.checkLogin()){
					this.$router.push('/login');
					return
				}
				this.$router.push('/classIndex');
			},
			checkMobile() {
				this.isMobile = window.innerWidth < 768;
			},
			toBecomeTeacher(){
				if(!this.checkLogin()){
					this.$router.push('/login');
					return
				}
				this.$router.push('/beforeBecomeTeacher');
			},
		}
	};
</script>

<style lang="less" scoped>
	::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header{
		color: #52C4C9 !important;
		font-size: 1.25rem;
	}
	.mainIndex-used-circle{
		width: 30px;
		height: 30px;
		border-radius: 50%;
		font-size: 1.25rem;
		text-align: center;
		line-height: 30px;
		margin-right: 16px;
	}
	.mainIndex-photo{
		width: 60px;
		height: 60px;
		margin-right: 10px;
	}

	.mainIndex-class-item {
		width: calc(100% / 4);
		height: 80px;
		margin: 10px;
	}

	.mainIndex-language-item {
		width: 30%;
		margin: 10px 15px;
		height: 80px;
	}

	.mainIndex-class-search {
		width: 300px;
		height: 40px;
		::v-deep.ant-input-affix-wrapper .ant-input {
			height: 40px;
			font-size: 16px;
		}
	}

	.mainIndex-teacher {
		width: 100%;
		background-image: url('../assets/image/index/becomeTeacher.jpg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}

	.mainIndex-teacher-btn {
		background-color: #fff;
		color: #52C4C9;
		border-radius: 30px;
		width: 220px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-top: 1.5rem;
	}

	.form-select {
		background-color: transparent;
		border: none;
		background-image: none;
		width: fit-content;
		// font-size: 1.5rem;
		font-weight: 600;
	}

	.form-select:focus {
		outline: none;
		box-shadow: none;
	}

	.vertical-steps {
		width: 100%;
		margin-top: 2rem;
		position: relative;
	}

	/* 竖线 */
	.vertical-steps::before {
		content: '';
		position: absolute;
		left: 12px;
		top: 20px;
		height: calc(100% - 40px);
		width: 2px;
		background-color: #ccc;
	}

	.step-item {
		display: flex;
		margin-bottom: 2rem;
		position: relative;
	}

	.step-number {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background-color: #E61979;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		margin-right: 2rem;
		z-index: 1;
	}

	.step-content {
		flex: 1;
	}

	.step-title {
		// font-size: 1.2rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
	}

	.step-description {
		font-size: 1rem;
		color: #666;
	}

	/* 轮播图 */
	.ant-carousel .custom-slick-arrow {
		width: 40px;
		height: 40px;
		font-size: 30px;
		color: #000;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.5;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
	}

	.ant-carousel .custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel .custom-slick-arrow:hover {
		opacity: 0.5;
	}

	::v-deep .ant-carousel .slick-dots li button {
		background-color: #C9C9C8;
		width: 15px;
		height: 15px;
	}

	::v-deep.ant-carousel .slick-dots li.slick-active button {
		background-color: #52C4C9 !important;
		width: 20px;
		height: 20px;
	}
	.main-wid-30{
		width: 30% !important;
		height: 300px;
	}
	@media (max-width: 575.98px) {
		.main-wid-30{
			width: 100% !important;
			margin-bottom: 15px;
			height: 300px;
		}
		.main-wid-100 {
			width: 100% !important;
		}

		.main-mp-1 {
			margin-top: 1rem;
		}

		.mainIndex-class-item {
			width: 45%;
			height: 80px;
			margin: 10px;
		}

		.mainIndex-language-item {
			width: 100%;
			margin: 5px;
		}

		.mainIndex-class-search {
			width: 100%;
			height: 50px;

			::v-deep.ant-input-affix-wrapper .ant-input {
				height: 50px;
				border-radius: 8px;
				font-size: 16px;
			}
		}

		.mainIndex-class-car {
			padding: 0 4rem;
		}
	}





	@media (min-width: 576px) {
		.container {
			margin: auto;
			width: 700px;
		}

		.mainIndex-pic1 {
			width: 45%;
		}
		.mainIndex-class-item {
			width: calc((100% - 40px) / 2);
			height: 80px;
			margin: 10px;
		}
		.mainIndex-language-item {
			width: 40%;
			margin: 10px ;
		}
		
	}

	@media (min-width: 768px) {
		.container {
			margin: auto;
			width: 800px;
		}

		.mainIndex-pic1 {
			width: 45%;
		}

		.mainIndex-class-item {
			width: calc((100% - 60px) / 3);
			height: 80px;
			margin: 10px;
		}
	}

	@media (min-width: 1200px) {
		.container {
			margin: auto;
			width: 900px;
		}

		.mainIndex-pic1 {
			width: 45%;
		}

		.mainIndex-class-item {
			width: calc((100% - 84px) / 4);
			height: 80px;
			margin: 10px;
		}
		.mainIndex-language-item {
			width: 30%;
			margin: 10px ;
		}
	}
	
	@media (min-width: 1400px) {
		.container {
			margin: auto;
			width: 1100px;
		}
	}
</style>